<template>
    <div class="container">
        <div>
            <div class="content" v-watermark>
                <div class="header">
                    <div class="title">
                        <span class="bold">润生医荃宜互联网医院会诊订单</span>
                    </div>
                </div>
                <van-row>
                    <van-col span="24">
                        <span>会诊单号：</span>
                        <span>{{ data.consultationNo }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>会诊人：</span>
                        <span>{{ data.memberName }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>性别：</span>
                        <span>{{ data.memberSex | sexFilter(data.memberSex)  }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>年龄：</span>
                        <span>{{ data.memberAge + "岁" }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>电话：</span>
                        <span>{{ data.memberMobile }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>就诊号：</span>
                        <span>{{ data.askNo }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>项目：</span>
                        <span>{{ data.classify | classifyFilter(data.classify) }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>会诊医生：</span>
                        <span>{{ data.consultationDoctorName }}</span>
                    </van-col>
                </van-row>


                <van-row class="row-item">
                    <van-col span="24">
                        <span>订单金额：</span>
                        <span class="black">￥{{ data.totalFee }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>支付金额：</span>
                        <span class="red">￥{{ data.totalFee }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>支付状态：</span>
                        <span :class="data.status || data.status == 0? 'status-'+ data.status : ''">{{ data.status | consultationOrderStatusFormat(data.status)  }}</span>
                    </van-col>
                </van-row>
            </div>
        </div> 
        <div class="footer" v-if="this.data.status == 0">
            <van-button class="call" type="primary" @click="openDialog" :disabled="!payData.PaySkipUrl">
                付款二维码
            </van-button>
            <van-button class="coupon" type="primary" @click="onCopeLink" :disabled="!payData.PaySkipUrl">复制付款链接</van-button>
        </div>  
        <prev-page :text="'返回首页'" @back="back"></prev-page> 

        <van-dialog v-model="dialogState.show" title="付款二维码" confirmButtonColor="#1989fa">
            <div class="qr-box">
                <img :src="dialogState.url" class="qr-img-box" />
                <div class="qr-title">请长按复制保存支付二维码</div>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import request from '@/utils/request.js'
import qrcode from 'qrcode'
import { uploadOther } from "@/api/index";
import { base64ToFile } from '@/utils/utils'
export default {
    data() {
        return {
            no: "",
            data: {},
            payData:{},
            timer:null,
            dialogState: {
                show: false,
                url: ''
            }
        };
    },
    created() {
        this.no = this.$route.query.no;
        this.getPayDetails();
        this.getRecordDetails()
    },
    methods: {
        getPayDetails() {
            request({
                url: `/order-service/pay/unifiedOrderV2`,
                method: 'post',
                data: {
                    orderNo: this.no,
                    origin: 2,
                    payType: 1,//支付宝支付
                }
            }).then((res) => {
                this.payData = res.data;
                this.payData.PaySkipUrl = res.data.paySkipUrl
            }).catch(() => {
                
            })
        },
        getRecordDetails() {
            request({
                url: `/doctor-service/doctorConsultation/order/detail/${this.no}`,
                method: 'get',
            }).then((res) => {
                this.data = res.data;
                // if(this.data.status == 1){
                //     //已支付
                //     this.$router.back();
                // }
            }).catch(() => {
                
            })
        },
        onCopeLink() {
            const input = document.createElement('input')
            input.value = this.payData.PaySkipUrl
            document.body.appendChild(input)
            input.select()
            document.execCommand('Copy')
            document.body.removeChild(input)
            this.$toast('复制成功');
        },
        openDialog(){
            try {
                var opts = {
                    errorCorrectionLevel: 'H',
                    type: 'image/jpeg',
                    quality: 0.3,
                    margin: 1,
                    color: {
                        light: "#fff"
                    }
                }
                qrcode.toDataURL(this.payData.PaySkipUrl, opts, async (err, base64Url) => {
                    if (err) throw err
                    // base 64 转file
                    const formData = new FormData();
                    formData.append("file", base64ToFile(base64Url,'付款二维码.jpeg'));
                    formData.append("module", "efficacy");
                    formData.append("category", "track");
                    formData.append('async', 'false') // 正式环境 接口返回慢了
                    const { data } = await uploadOther(formData)
                    this.dialogState = {
                        show: true,
                        url: data.absoluteUrl
                    }
                })
            } catch (error) {
                console.log(error)
            }
        },
        back() {
            this.$router.back();
        },
    },
};


</script>
<style lang="scss" scoped>
$border-color: #dcdfe6;
.container {
    padding: 10px;
    padding-bottom: 90px;

    .content {
        background: #fff;
        padding: 0 26px;
        border-radius: 4px;
        margin-bottom: 10px;

        &:last-child {
            padding-bottom: 12px;
        }

        .header {
            padding: 22px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            .title {
                display: flex;
                align-items: center;
                .bold {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                }
                .desc {
                    color: #ee9e2e;
                    margin-left: 5px;
                    font-size: 14px;
                }
            }
        }

        :deep() .van-col {
            font-size: 14px;
            margin-bottom: 14px;

            span {
                &:first-child {
                    color: #999;
                    margin-right: 20px;
                }
            }
        }

        :deep() .van-cell {
            padding: 0;
            font-size: 14px;

            .van-cell__title {
                margin-right: 20px;
                width: auto;
            }

            .van-cell__value {
                background: #f6fbff;
                padding: 0 10px;
            }

            &::after {
                border: none;
            }
        }
    }
}
.footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 20px 20px 26px 20px;
    box-sizing: border-box;
}
.row-item{
    border-top: 1px solid $border-color;
    padding-top: 20px;
}
.qr-box {
    padding: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;

    .qr-title {
        margin-top: 20px;
        font-size: 16px;
    }

    .qr-img-box {
        width: 150px;
        height: 150px;
    }
}
.status-0{
    color: #f56c6c
}
.status-1{
    color:#289836
}
.black {
    color: #000;
}
.red {
    color: #f00;
    font-size: 18px;
    font-weight: bold;
}
</style>
